import {Box, Divider} from "@chakra-ui/react";
import React from "react";

function CartItemDivider(props) {
    return (
        <Box pt={4} pb={4}>
            <Divider variant='dashed' opacity='1'/>
        </Box>
    )
}

export default CartItemDivider